import React from "react";
import "./style.css";

export default function NotFound() {
  return (
    <>
      <div class="container">
        <div class="copy-container center-xy">
          <p>404, page not found.</p>
        </div>
      </div>
    </>
  );
}
